<template>
  <v-dialog
    v-model="dialog"
    width="1160px">
    <div class="dialog-container">
      <h2>Mark As Done</h2>
      <p>Please enter reference numbers for each transaction.</p>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <el-table
          :data="formData.tableData"
          stripe
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"></el-table-column>
          <el-table-column
            prop="card_holder"
            label="Bank Account Holder"></el-table-column>
          <el-table-column
            prop="card_bank"
            label="Bank"></el-table-column>
          <el-table-column
            prop="card_number"
            label="Bank Account No."></el-table-column>
          <el-table-column
            prop="amount"
            label="Amount">
          </el-table-column>
          <el-table-column
            label="Transaction No.">
            <template #default="scope">
              <el-form-item 
                :rules="rules.transaction_no"
                :prop="'tableData.' + scope.$index + '.transaction_no'">
                <v-input v-model="formData.tableData[scope.$index].transaction_no" />
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="dialog-footer">
        <div>
          <v-button @click="dialog = false">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="onDone">Done</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { setCreditDone } from '@/api/credits'
export default {
  name: 'MarkDoneDialog',
  props: {
    selectionData: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        tableData: [],
      },
      rules: {
        transaction_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  watch: {
    selectionData: {
      immediate: true,
      deep: true,
      handler(list) {
        this.formData.tableData = list.reduce((result, item) => {
          result.push({
            ...item,
            transaction_no: ''
          })
          return result
        }, [])
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    onDone() {
      this.$refs.form.validate(valid => {
        if(valid) {
          const list = this.formData.tableData.reduce((result, item) => {
            const { id, transaction_no } = item
            result.push({
              id,
              transaction_no
            })
            return result
          }, [])
          this.network().setCreditDone({
            transfer: list
          })
        }
      })
    },
    network() {
      return {
        setCreditDone: async (params) => {
          const { data } = await setCreditDone(params)
          this.$emit('done', data)
          this.dialog = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    h2 {
        padding-bottom: 5px;
        & + p {
            padding-bottom: 10px;
            font-size: 16px;
            color: #616266;
        }
    }
    .dialog-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
    }
}
</style>